import React from "react";
import clsx from "clsx";
import { useDispatch, useSelector } from "react-redux";
import { setIsMeasurementListDrawerOpen } from "../../reducers/measurement-reducer";
import useLanguageChange from "../../hooks/useLanguageChange";
import googleEvent from "../../services/googleEvent";
import { EVENT_NAME } from "../../constants/GTagConstants";
import { CopyTextOrLinkToClipboard } from "../../shared/utility";

const MeasurementListDrawer = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const { isMeasurementListDrawerOpen, measurementList } = useSelector((state) => state.measurement);

    const handleCloseDrawer = () => {
        dispatch(setIsMeasurementListDrawerOpen(false));
    };

    const copyMeasurementList = (index) => {
        let measure = "Measurement";
        let finalString = "";

        if (index != undefined) {
            googleEvent.logEvent(EVENT_NAME.MEASUREMENT_COPY_TAPPED);
            finalString =
                measure +
                "\n" +
                measurementList[index].highlight_measurement +
                " " +
                measurementList[index].highlight_measurement_unit +
                " (" +
                measurementList[index].sub_measurement_unit_first +
                ", " +
                measurementList[index].sub_measurement_unit_second +
                ")\n";
        } else {
            googleEvent.logEvent(EVENT_NAME.MEASUREMENT_COPY_ALL_TAPPED);
            measurementList.forEach((obj) => {
                const str =
                    measure +
                    "\n" +
                    obj.highlight_measurement +
                    " " +
                    obj.highlight_measurement_unit +
                    " (" +
                    obj.sub_measurement_unit_first +
                    ", " +
                    obj.sub_measurement_unit_second +
                    ") \n";
                finalString = finalString + str;
            });
        }
        CopyTextOrLinkToClipboard(finalString, localisedValues?.measurement_copyall_msg);
    };

    return (
        <div
            className={clsx("sidebar right-sidebar ar-measurement-sidebar", isMeasurementListDrawerOpen && "active")}
            id='ar-measurement-sidebar'
            data-testid='measurement-list-drawer'
        >
            <div className='sidebar-in'>
                <div className='sidebar-head'>
                    <div className='sidebar-head-title'>
                        <div className='title'>
                            {localisedValues["measurements"]} <span className='head-count'>({measurementList?.length})</span>
                        </div>
                    </div>
                    <div className='sidebar-head-right'>
                        <div className='sidebar-close'>
                            <button className='btn close-sidebar-button' data-testid='measurementListDrawerCloseBtn' onClick={handleCloseDrawer}>
                                <span className='for-icon icon-close-light'></span>
                            </button>
                        </div>
                    </div>
                </div>
                <div className='sidebar-body padding-0 custom-scroll'>
                    <div className='ar-measurement-list'>
                        {measurementList?.map((measure, index) => {
                            return (
                                <div className='ar-measurement-box' key={`measurementList_${index}`}>
                                    <div className='measurement-icon'>
                                        <span className='for-icon icon-mesure-vertical-bar'></span>
                                    </div>
                                    <div className='measure-main'>
                                        {measure.highlight_measurement} {measure.highlight_measurement_unit}
                                    </div>
                                    <div className='measure-other'>
                                        <div className='measure-other-unit'>{measure.sub_measurement_unit_first}</div>
                                        <div className='measure-other-unit'>{measure.sub_measurement_unit_second}</div>
                                    </div>
                                    <div className='copy-measure-button custom-tooltip tooltip-auto-width m-hide'>
                                        <button className='btn copy-btn' onClick={() => copyMeasurementList(index)}>
                                            <span className='btn-icon icon-copy-code'></span>
                                        </button>
                                        <div className='custom-tooltip-content text-nowrap'>
                                            <div className='custom-tooltip-in'>
                                                <p>{localisedValues["copy"]}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
                <div className='sidebar-foot'>
                    <div className='button-inline d-flex justify-content-end'>
                        <div className='button'>
                            <button className='btn btn-primary btn-sm' onClick={() => copyMeasurementList()}>
                                <span className='btn-text'>{localisedValues["copy_all"]}</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MeasurementListDrawer;
